export const PHONE_DISPLAY = "07717 759310";
export const PHONE_TEL = "tel:+447717759310";
export const EMAIL = "info@expressbreakdown.com";
export const SERVICE_AREA = "UK — London & surrounding areas";
export const BRAND = "ExpressBreakdown";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_55ce6ff3-aefc-4862-a06b-ff3369c991ec/artifacts/0is8ywms_ChatGPT%20Image%20May%204%2C%202026%2C%2006_50_41%20PM%202.svg";
export const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_55ce6ff3-aefc-4862-a06b-ff3369c991ec/artifacts/8mzj059n_IMG_2910.JPG";
export const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_55ce6ff3-aefc-4862-a06b-ff3369c991ec/artifacts/36d330jo_IMG_3390.JPG";
export const SERVICE_IMG_ROADSIDE =
  "https://images.unsplash.com/photo-1763377278900-0ce8242c5005?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const SERVICE_IMG_TYRE =
  "https://images.unsplash.com/photo-1764015805414-df7de89d405b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const SERVICE_IMG_RECOVERY =
  "https://images.pexels.com/photos/17429097/pexels-photo-17429097.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
